import React from 'react';
import SparePartsFinderTextSearchFilterPanel
    from '../spare-parts-finder-text-search/SparePartsFinderTextSearchFilterPanel';

export default class SparePartsFinderProductSerialNumberFilterPanel extends SparePartsFinderTextSearchFilterPanel {
    getCaption = () => __('S/N');
}